export default __webpack_public_path__ + "media/components/Header/Images/Close-4b79262086124c234245cdcebccb949c.svg";